export const isWebp = (src) => {
    return /\.webp$/.test(src);
};
export const loadImgData = (src) => {
    return new Promise((res, rej) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', src);
        xhr.responseType = 'arraybuffer';
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
                const data = new Uint8Array(xhr.response);
                res(data);
            }
        };
        xhr.send();
    });
};
export const decode = (imgData, canvas) => {
    let Module = window.__IFENG_WEBP_MODULE__;
    const canDecode = (Module) => {
        return Module["asm"] !== undefined;
    };
    return new Promise((res, rej) => {
        const check = setInterval(() => {
            if (canDecode(Module)) {
                clearInterval(check);
                let WebpToCanvas = Module.cwrap('WebpToSDL', 'number', ['array', 'number']);
                Module.canvas = canvas;
                canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
                WebpToCanvas(imgData, imgData.length);
                res(canvas.toDataURL());
            }
        }, 50);
    });
};
